import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=d904e7f4&"
import script from "./EditForm.vue?vue&type=script&lang=js&"
export * from "./EditForm.vue?vue&type=script&lang=js&"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=d904e7f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports